import zh from '../assets/language/zh-cn.json'
import { GoPost } from '../method/Post';
import ls from '../method/localStorage';
export class Menu{
    public Menu:Array<subMenu>;
    public version:number
    constructor(Menu:Array<subMenu>=[],version:number=0){
        this.Menu=Menu;
        this.version=version;
    }

    public init(langPack:any=zh,success:Function=()=>{}){
        let data={
            userId:ls.get("WebUserId"),
            userToken:ls.get("WebToken"),
            moduleId:ls.get("ModuleId"),
        }
        GoPost("/WebMenu/WebMenu",data,(res:any)=>{
            this.Copy(res.menu.subMenus);
            this.version=res.version;
            ls.set("Menu",this);
            success()
        },langPack)
    }

    

    public Copy(target:Array<subMenu>){
        target.forEach(ele=>{
            let newItem=new subMenu();
            newItem.Copy(ele);
            this.Menu.push(newItem);
        })
    }

    public changeLangPack(langPack:any=zh){
        this.Menu.forEach(ele=>{
            ele.changeLanguage(langPack);
        })
    }

    public find(index:string){
        let split=index.split('-');
        let mainIndex=this.Menu.findIndex(m=>m.index==split[0]);
        if(mainIndex>-1){
            let subIndex=this.Menu[mainIndex].subMenus.findIndex(m=>m.index==index);
            if(subIndex>-1){
                return this.Menu[mainIndex].subMenus[subIndex];
            }else{
                return this.Menu[mainIndex];
            }
        }
        else{
            return new subMenu();
        }
    }
}

export class subMenu{
    public id:number;
    public index:string;
    public name:string;
    public desc:string;
    public subMenus:Array<subMenu>
    constructor(id:number=0,index:string="0",name:string="",desc:string="",subMenu:Array<subMenu>=[]){
        this.id=id;
        this.index=index;
        this.name=name;
        this.desc=desc;
        this.subMenus=subMenu;
    }

    public changeLanguage(langPack:any=zh){
        this.desc=Reflect.get(langPack,this.name);
        this.subMenus.forEach(ele=>{
            ele.changeLanguage(langPack);
        })
    }

    public Copy(target:subMenu){
        this.id=target.id;
        this.index=target.index;
        this.name=target.name;
        this.desc=target.desc;
        this.subMenus=[];
        target.subMenus.forEach(ele=>{
            let newItem=new subMenu();
            newItem.Copy(ele);
            this.subMenus.push(newItem);
        })
    }
}
